export default __webpack_public_path__ + "7a0f1075208803f0a1b2f5dd5ef8ef3b.png";